import { render, staticRenderFns } from "./pendingToMake.vue?vue&type=template&id=5b6b0630&scoped=true"
import script from "./pendingToMake.vue?vue&type=script&lang=js"
export * from "./pendingToMake.vue?vue&type=script&lang=js"
import style0 from "./pendingToMake.vue?vue&type=style&index=0&id=5b6b0630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b0630",
  null
  
)

export default component.exports